import React from 'react';
import type { EntityName } from '../../common/auth/Security';
import DataListRowActions from '../../common/list/DataList/DataListRowActions';
import type { DataListCustomRowAction } from '../../common/list/DataList/types';
import { DataListCellContainerProps } from './DataListCellContainer';

type DataListCellActionsProps = Omit<
    DataListCellContainerProps,
    'children' | 'enableSelectItem' | 'selectedItemId' | 'updatedSelectedItemId' | 'onNotesPanelToggle'
> & {
    /**
     * Optional only to support callers that still rely on the legacy permission fallback.
     * Make required once those callers forward it and the missing-entity fallback is removed.
     */
    entity?: EntityName;
    customRowActions?: DataListCustomRowAction[];
    isActivated?: boolean;
};

export default function DataListCellActions({
    item,
    feature,
    entity,
    actionHandlers,
    customRowActions = [],
    isActivated
}: DataListCellActionsProps) {
    return (
        <DataListRowActions
            item={item}
            feature={feature}
            entity={entity}
            actionHandlers={actionHandlers}
            customRowActions={customRowActions}
            isActivated={isActivated}
        />
    );
}
